var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoubleHouse = function SvgDoubleHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.072 4.357a1.25 1.25 0 0 0-2.152.013l-11.666 20a1.25 1.25 0 0 0 1.08 1.88h3.75v7.083c0 .69.559 1.25 1.25 1.25h8.333c.69 0 1.25-.56 1.25-1.25V25c0-.69-.56-1.25-1.25-1.25h-1.18L20 15.853l4.513 7.897h-1.18c-.69 0-1.25.56-1.25 1.25v8.333c0 .69.56 1.25 1.25 1.25h8.334c.69 0 1.25-.56 1.25-1.25V26.25h3.75a1.25 1.25 0 0 0 1.08-1.88l-11.667-20a1.25 1.25 0 0 0-2.152-.013L20 10.904zM5.51 23.75l9.505-16.295 3.537 5.894-6.304 11.03a1.25 1.25 0 0 0 1.085 1.871h2.084v5.833H9.583V25c0-.69-.56-1.25-1.25-1.25zm22.242.63-6.303-11.031 3.536-5.894L34.49 23.75h-2.823c-.69 0-1.25.56-1.25 1.25v7.083h-5.834V26.25h2.084a1.25 1.25 0 0 0 1.085-1.87",
    clipRule: "evenodd"
  })));
};
export default SvgDoubleHouse;